import axios from "axios";

export default axios.create({
  baseURL: "https://denmercsphotography-be.herokuapp.com"
});
